import { grayColor } from "../../material-dashboard-pro-react";

const customTextFieldStyle = (theme) => ({
  root: {
    "& > div": {
      backgroundColor: grayColor[13],
      "& > textarea": {
        paddingLeft: "8px",
        paddingRight: "8px",
        fontSize: "12px",
      },
    },
    "& > label": {
      color: grayColor[0],
      paddingLeft: "8px",
      zIndex: "9999",
    },
    "& label.Mui-focused": {
      color: grayColor[0],
    },
    "& .MuiInput-underline": {
      "&:before": {
        borderColor: grayColor[4] + " !important",
        borderWidth: "1px !important",
      },
      "&:after": {
        borderColor: theme.palette.custom.clientColor,
      },
      "& + p": {
        fontWeight: "300",
      },
    },
  },
});

export default customTextFieldStyle;
